<!--
 * @Author: LHH
 * @Date: 2019-08-12 15:08:25
 -->
<template>
  <div class="main home">
    <div class="banner">
      <h2 class="title">专业跨境电商 ERP 系统</h2>
      <p class="msg">Your Amazon success starts with JiuTianData</p>
    </div>
    <div class="product">
      <h2 class="title">
        <p class="title-main">产品定位</p>
        <p class="title-sub">Product Positioning</p>
      </h2>
      <ul class="shop">
        <li class="shop-item" v-for="(item, index) in shopData" :key="index">
          <div
            class="pic"
            :style="{ backgroundImage: 'url(' + item.pic + ')' }"
          ></div>
          <h3 class="title">{{ item.title }}</h3>
          <p class="content">{{ item.content }}</p>
        </li>
      </ul>
    </div>
    <ImgTextList v-bind:list="imgTextData"></ImgTextList>
  </div>
</template>

<script>
// @ is an alias to /src
import ImgTextList from '@/components/home/ImgTextList.vue'

export default {
  name: 'Home',
  metaInfo: {
    title: '广州鲸灵科技有限公司官网 - 九天数据 -跨境电商大数据平台-亚马逊Amazon数据分析,JiuTianData',
    meta: [
      {
        name: 'keyWords',
        content:
          '广州鲸灵科技有限公司官网 - 九天数据 ,亚马逊数据,Amazon数据,亚马逊关键词,亚马逊选品,跨境数据分析,数据分析,Amazon，亚马逊数据分析,跨境电商A'
      },
      {
        name: 'description',
        content:
          '广州鲸灵科技有限公司官网 - 九天数据 专注于Amazon大数据分析服务，Amazon防跟卖监控、亚马逊竞品监控、亚马逊库存监控、亚马逊关键词挖掘、Amazon CPC关键词投放、Amazon评价分析、亚马逊Best Seller选品、亚马逊行业蓝海分析、亚马逊店铺分析、亚马逊关键词排名监控、营销工具等功能助力跨境商家抢占全球市场'
      }
    ]
  },
  data() {
    return {
      imgTextData: [
        {
          title: '集团化，多公司统一的管理平台',
          content:
            '多公司的组织架构如何管理，数据独立性和统一性如何保障。何如进行整体的协同。统统帮您搞定。',
          pic: require('../assets/img/home/Bitmap1.png')
        },
        {
          title: '海量数据，挖掘新产品',
          content:
            '从海量的数据中挖局新的商机，洞察细分市场机遇，轻松掌控潜力商品。',
          pic: require('../assets/img/home/Bitmap.png')
        },
        {
          title: '竞对分析管理',
          content:
            '商场如战场，知己知彼百战不殆，竞对店铺、ASIN分析，实时了解最新动态。',
          pic: require('../assets/img/home/Collaboration.png')
        }
      ],
      shopData: [
        {
          title: '数据安全',
          content: '专业为跨境电商企业设计，支持私有化部署，保证数据安全',
          pic: require('../assets/img/home/pro-icon0.png')
        },
        {
          title: '功能模块化',
          content: '支持公司多个子公司人员，数据统一管理，团队协作更高效',
          pic: require('../assets/img/home/pro-icon1.png')
        },
        {
          title: '数据可视化',
          content: '从海量数据，分析可视化数据业务流程化，数据化。',
          pic: require('../assets/img/home/pro-icon2.png')
        },
        {
          title: 'Amazon解决方案',
          content: '类目数据分析，review分析、竞对监控等，多种解决方案',
          pic: require('../assets/img/home/pro-icon3.png')
        }
      ]
    }
  },
  components: {
    ImgTextList
  }
}
</script>

<style lang="less" scoped>
//banner
.banner {
  padding: 100px 70px;
  height: auto;
  min-height: 500px;
  position: relative;
  overflow: hidden;
  background-image: url('../assets/img/home/banner02.png');
  background-repeat: no-repeat;
  background-position: right 20px;
  background-size: 548px 422px;

  &::after {
    display: block;
    content: '';
    width: 100%;
    height: 200px;
    background-color: #2f54eb;
    position: absolute;
    bottom: -100px;
    left: 0;
    transform: skewY(-5.1deg);
  }
  .title {
    width: 900px;
    height: 102px;
    line-height: 102px;
    height: auto;
    margin-bottom: 43px;
    position: relative;
    font-size: 68px;

    &::after {
      display: block;
      content: '';
      position: absolute;
      width: 14px;
      height: 14px;
      right: calc(100% + 5px);
      bottom: calc(100% - 5px);
      border: 2PX solid #2f54eb;
      border-radius: 50%;
    }
  }
  .msg {
    width: 680px;
    height: auto;
    font-size: 27px;
    color: #0d1a26;
    margin-bottom: 80px;
  }
}

//产品定位
.product {
  height: auto;
  background-color: #2f54eb;

  > .title {
    height: auto;
    text-align: center;
    font-size: 48px;
    padding-top: 46px;

    > * {
      color: #ffffff;
      font-weight: bold;
    }
    .title-main {
      margin-bottom: 9px;
    }
    .title-sub {
      font-size: 21px;
    }
  }
  > .shop {
    display: flex;
    padding: 0 130px;
    flex-wrap: wrap;
    padding-top: 90px;

    .shop-item {
      width: calc(25% - 55px);
      height: auto;
      flex-shrink: 0;
      margin: 0 auto;
      margin-bottom: 70px;

      > * {
        color: white;
      }
      .pic {
        display: block;
        width: 120px;
        height: 120px;
        margin: 0 auto 30px;
        background-color: white;
        background-position: center;
        background-size: auto 60px;
        background-repeat: no-repeat;
        border-radius: 50%;
      }
      .title {
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .content {
        font-size: 14px;
      }
    }
  }
}
@media screen and (min-width: 720px) {

}
@media screen and (min-width: 0px) and (max-width: 720px) {
  .banner {
    .title {
      width: 100%;
      text-align: center;
      font-size: 46PX;
    }
    .msg {
      width: 100%;
      text-align: center;
      font-size: 21PX;
      padding: 0 20px;
    }
  }
  .product {
    > .title {
      font-size: 32PX;
      .title-sub {
        font-size: 21PX;
      }
    }
    > .shop {
      display: flex;
      padding: 0 130px;
      flex-wrap: wrap;
      padding-top: 90px;

      .shop-item {
        width: calc(50% - 55px);
        .pic {
          display: block;
          width: 240px;
          height: 240px;
        }
        .title {
          font-size: 20PX;
        }
        .content {
          font-size: 14PX;
        }
      }
    }
  }
}
</style>
